export const LoginInfo: React.FC = () => (
  <div className='App__info-message'>
    <h2>
      <strong>Please login to use this demo</strong>
    </h2>
    <p>We only need your login data for preventing misuse.</p>
    <p>
      We <strong>never</strong> contact you via your e-mail and will <strong>never</strong> use it for any other
      marketing purposes.
    </p>{' '}
    <p>You can use your Github account to login after clicking the login button.</p>
  </div>
);
